<template>
  <vx-card :title="lecture.title"
            :subtitle="lecture.groups ? `المجموعة ( ${lecture.groups.join(', ')} )` : null">
    <div slot="actions">
      <div v-if="!lecture.is_visible" class="flex items-center">
        <feather-icon svg-classes="h-4 w-4" icon="EyeOffIcon" />
        <span class="ml-2">المحاضرة غير مرئية للطلبة</span>
      </div>
    </div>
    <p>{{lecture.body ? lecture.body : '' | removeTags}}</p>
    <div slot="footer" class="flex items-center justify-between">
      <p class="text-gray">
        <feather-icon icon="CalendarIcon" svg-classes="h-4 w-4"/>
        <span class="ml-2">{{lecture.date | date}}</span>
      </p>
      <vs-button @click="openLecture()" class="flex ml-auto" icon="icon-chevrons-left" icon-pack="feather" icon-after>عرض</vs-button>
    </div>
  </vx-card>
</template>

<script>
    export default {
        name: 'lectureItem',
        props: {
            lecture: {
                type: Object,
                required: true
            },
        },

        filters: {
            removeTags(str) {
                let temporalDivElement = document.createElement("div");
                temporalDivElement.innerHTML = str;
                return temporalDivElement.textContent || temporalDivElement.innerText || "";
            }
        },
        methods: {
            openLecture() {
                const params = { course_id: this.$route.params.course_id, lecture_id: this.lecture.id }
                this.$router.push({ name: 'courseLecture', params })
            },
        }
    }
</script>
